import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { number } from "yup";

function ProceedPayment() {
  const navigate = useNavigate();
  const Location = useLocation();

  const { id } = useParams();
  console.log("iddddd", Location);
  const thead = [
    { title: "item" },
    { title: "Qty" },
    { title: "price" },
    { title: "total" },
  ];
  const Bill = [
    { title: "item 1", quantity: "3", price: "200", total: "200" },
    { title: "item 2", quantity: "2", price: "300", total: "600" },
    { title: "item 3", quantity: "1", price: "100", total: "200" },
    { title: "item 4", quantity: "2", price: "200", total: "400" },
  ];
  const TotalPrice = () => {
    let total = 0;
    Bill.map((val, i) => {
      // console.log(val.total);
      total = total + Number(val.total);
    });
    return total;
    // console.log(total);
  };
  // const Totals = () => {
  let qty = [];
  Bill.map((val, i) => {
    val.total = Number(val.quantity) * Number(val.price);
    return qty.push(val.total);
  });
  console.log(qty);
  // };
  // console.log(Totals());
  return (
    <div className="">
      <div className="p-20 font-serif ">
        <div className="flex flex-col w-[30%]  mx-auto border shadow-xl shadow-slate-300 px-10 py-12">
          <div className="text-center">
            *****************************************
          </div>
          <div className=" uppercase text-center font-serif font-bold text-lg my-3">
            reciept
          </div>
          <div className="text-center">
            *****************************************
          </div>
          <div className=" flex justify-between items-center my-3">
            <div className="flex flex-col">
              <div className="capitalize font-semibold">terminal#1</div>
            </div>
            <div className="flex  items-center text-sm  text-gray-600 font-medium gap-3">
              <div>2023/10/22</div>
              <div>02:10 P.M</div>
            </div>
          </div>
          <div className="">
            --------------------------------------------------
          </div>
          <table>
            <thead>
              <tr>
                {thead.map((val, i) => {
                  return (
                    <td key={i} className="capitalize border-b pb-3">
                      {val.title}
                    </td>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {Bill.map((val, i) => {
                let tot = Number(val.quantity) * Number(val.price);
                return (
                  <tr key={i} className="   w-full ">
                    <td>
                      <div className=" font-medium pt-3 font-serif text-lg capitalize text-gray-600">
                        {val.title}
                      </div>
                    </td>
                    <td>
                      <div className=" font-medium  font-serif text-lg capitalize text-gray-600">
                        {val.quantity}
                      </div>
                    </td>
                    <td>
                      {" "}
                      <div className="font-semibold text-base">
                        Rs. {val.price}
                      </div>
                    </td>
                    <td>
                      <div className=" font-medium  font-serif text-lg capitalize text-gray-600">
                        {/* {Totals()}
                         */}
                        {tot.toFixed(2)}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {/* <div className="my-3">
            {Bill.map((val, i) => {
              return (
                <div key={i} className="my-4 flex justify-between items-center">
                  <div className=" font-medium  font-serif text-lg capitalize text-gray-600">
                    {val.title}
                  </div>
                  <div className="font-semibold text-base">Rs. {val.price}</div>
                </div>
              );
            })}
          </div> */}
          <div className="leading-3 mb-8">
            <div className="">
              {" "}
              --------------------------------------------------
            </div>
            <div className="">
              {" "}
              --------------------------------------------------
            </div>
          </div>
          <div className="flex justify-between items-center">
            <div className="font-semibold capitalize font-serif ">
              total amount
            </div>
            <div className="text-sm font-semibold font-serif ">
              {" "}
              Rs. {TotalPrice()}
            </div>
          </div>{" "}
          <div className="">
            {" "}
            --------------------------------------------------
          </div>
          <div className="uppercase font-serif font-semibold text-lg">
            ********* thank you! *********
          </div>
          <div className="text-center">
            ****************************************
          </div>
          <div className="mx-auto w-fit mt-5" onClick={() => navigate(-1)}>
            {" "}
            <button className="px-4 py-2 bg-red-500 text-white ">Back</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProceedPayment;
